import { render } from "./logTip.vue?vue&type=template&id=64ac26cc"
import script from "./logTip.vue?vue&type=script&lang=js"
export * from "./logTip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__